import styled from 'styled-components';
import { GlobalToken } from 'antd';

const TooltipContainer = styled.div<{ token: GlobalToken }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: ${({ token }) => token.fontSizeSM}px;
  z-index: 3;
  background-color: ${({ token }) => token.colorBgElevated};
  border-radius: 4px;

    &.system-degradation-container {
    width: 260px;
    
    .row > span:first-child {
      max-width: 50%;
    }
  }
  &.graph-tooltip-container {
    padding: ${({ token }) => token.paddingSM}px;
    width: 260px;
    height: 250px;
    background-color: ${({ token }) => token.colorBgElevated};
    color: ${({ token }) => token.colorText};
    border-radius: 10px;
  }
  &.system-overview-container {
    width: 230px;
  }

  .bullets-container {
    width: 96%;
    flex-direction: column;
    display: flex;
    align-content: space-between;
    margin-top: ${({ token }) => token.marginXS}px;
  }

  .top-right-sub-title {
    text-align: right;
    font-size: ${({ token }) => token.fontSizeSM}px;
    width: 91%;
    margin-top: -${({ token }) => token.marginXS}px;
  }

  .row {
    display: flex;
    flex-direction: row;
    width: 92%;
    height: 20px;
    justify-content: space-between;
    align-items: center;
    margin: ${({ token }) => token.marginXXS}px 0;
    
    > span:first-child {
      max-width: 70%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .percentage-numeral-values {
    display: flex;
    width: 50%;
  }
  .percentage-value {
    text-align: center;
    width: 40%;
  }

  .values-units-container {
    display: flex;
    justify-content: flex-end;
    width: 35%;
  }
  .numeral-value {
    text-align: left;
    padding-right: ${({ token }) => token.paddingXXS}px;
  }
  .numeral-value-na {
    text-align: center;
    width: 100%;
    padding-right: ${({ token }) => token.paddingXXS}px;
  }

  .unit {
    text-align: center;
  }

  .right-summary-value {
    text-align: right;
    width: 50px;
    padding-right: ${({ token }) => token.paddingXXS}px;
  }

  .tooltip-highlighted-content {
    background-color: ${({ token }) => token.colorBgContainer};
    color: ${({ token }) => token.colorText};
    border-radius: 2px;
    padding: ${({ token }) => token.paddingXXS}px;
    font-size: ${({ token }) => token.fontSizeSM}px;
    margin-top: ${({ token }) => token.marginXXS}px;
    width: 100%;
    display: flex;
    flex-direction: column;

    &.top {
      margin-bottom: ${({ token }) => token.marginXXS}px;
    }
    .row {
      width: 100%;
    }
  }

  .tooltip-summary {
    font-weight: ${({ token }) => token.fontWeightStrong};
  }

  .tooltip-icon {
    transform: scale(0.5);
    vertical-align: middle;
    filter: grayscale(100%);
    display: inline;
  }

  .bottom-lines {
    width: 93%;
  }
`;

export default TooltipContainer;
